export const TOGGLE_ROW = "TOGGLE_ROW";
export const TOGGLE_ALL_ROWS = "TOGGLE_ALL_ROWS";
export const RESET_SELECTED_ROWS = "RESET_SELECTED_ROWS";

export const toggleRow = (rowId, checked) => ({
   type: TOGGLE_ROW,
   payload: { rowId, checked },
});

export const toggleAllRows = (rowIds, checked) => ({
   type: TOGGLE_ALL_ROWS,
   payload: { rowIds, checked },
});

export const resetSelectedRows = () => ({
   type: RESET_SELECTED_ROWS,
});
